<template>
  <div class="datenschutzContainer">
    <Header
      name="Datenschutzhinweise für den Verkehrsservice Hessen von Hessen Mobil- Straßen- und Verkehrsmanagement"
    />
    <div class="datenschutzContent">
      <!-- ############################### -->
      <h4>
        Hinweise zur Verarbeitung Ihrer Daten gemäß Art. 13 der Europäischen Datenschutzverordnung (DSGVO) in Verbindung mit § 31 des Hessischen Datenschutz- und Informationsfreiheitsgesetzes (HDSIG) in der jeweils geltenden
        Fassung.
      </h4>
      <p>
        <a
          rel="noopener noreferrer"
          href="https://eur-lex.europa.eu/legal-content/DE/TXT/?qid=1528874672298&uri=CELEX%3A32016R0679"
          target="_blank"
        >https://eur-lex.europa.eu/</a>
        <br>
        <a
          rel="noopener noreferrer"
          href="https://www.rv.hessenrecht.hessen.de/lexsoft/default/hessenrecht_rv.html#docid:8074311,1,20180525"
          target="_blank"
        >https://www.rv.hessenrecht.hessen.de/</a>
      </p>

      <!-- ############################### -->
      <h4>Geltungsbereich</h4>
      <p>Diese Datenschutzhinweise gelten für das Internetangebot von Hessen Mobil – Straßen- und Verkehrsmanagement und für die über diese Internetseiten erhobenen personenbezogenen Daten. Für Internetseiten anderer Anbieter, auf die z. B. über Links verwiesen wird, gelten die dortigen Datenschutzhinweise und –erklärungen.</p>

      <!-- ############################### -->
      <h4>Verantwortlichkeit</h4>
      <p>
        Verantwortlich für die Verarbeitung personenbezogener Daten auf diesen Internetseiten ist Hessen Mobil – Straßen- und Verkehrsmanagement, Dostojewskistraße 4-6
        , 65187 Wiesbaden
        <br>(Tel. 0611 / 366-0;
        <a href="mailto:info@mobil.hessen.de">info@mobil.hessen.de</a>)
      </p>

      <!-- ############################### -->
      <h4>Behördlicher Datenschutzbeauftragter</h4>
      <p>Den behördlichen Datenschutzbeauftragten von Hessen Mobil – Straßen- und Verkehrsmanagement erreichen Sie über Hessen Mobil – Straßen- und Verkehrsmanagement, Datenschutzbeauftragter, Dostojewskistraße 4-6, 65187 Wiesbaden.</p>

      <!-- ############################### -->
      <h4>Technischer Dienstleister</h4>
      <p>
        Das Internetangebot wird von der TraffGo Road GmbH
        <br>(
        <a rel="noopener noreferrer" href="http://www.traffgoroad.de" target="_blank">»www.traffgoroad.com</a>) als technischem Dienstleister in unserem Auftrag und nach unseren Vorgaben vorgehalten. Die Verarbeitung erfolgt in unserem Auftrag und nach unseren Vorgaben entsprechend Art. 28 DSGVO i. V. m. § 57 HDSIG.
      </p>

      <h5>Zweck der Datenverarbeitung</h5>
      <p>Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person beziehen, also beispielsweise Namen, Anschriften, Telefonnummern, E-Mail-Adressen, Vertrags-, Buchungs- und Abrechnungsdaten, die Ausdruck der Identität einer Person sind.</p>
      <p>Wir erheben, verarbeiten und nutzen personenbezogene Daten (inklusive IP-Adressen) nur dann, wenn hierfür eine gesetzliche Rechtsgrundlage gegeben ist oder Sie uns diesbezüglich, z. B. im Rahmen einer Registrie-rung, Ihre Einwilligung gemäß Art 7 DSGVO und § 46 HDSIG erteilt haben.</p>

      <!-- ############################### -->
      <h4>Persönliches Profil (Mein Verkehrsservice)</h4>

      <h5>1. Zweck der Datenverarbeitung</h5>
      <p>Um persönliche Routen anzulegen, Nachrichten (mittels Push-Benachrichtigungen) zu aktuellen Verkehrslagen zu erhalten und angelegte Routen auf allen Geräten nutzen zu können bietet der Verkehrsservice Hessen dem Nutzer die Möglichkeit sich ein persönliches Profil anzulegen.</p>

      <h5>2. Beschreibung und Umfang der Datenverarbeitung</h5>
      <p>Bei der Einrichtung des persönlichen Profils wird dem Nutzer systemseitig eine Profilnummer vergeben. Das Profil ist nach Vergabe eines individuellen vom Nutzer selbst vergebenen Passwortes erstellt. Mittels der Profilnummer und des Passwortes kann das persönliche Profil genutzt werden. Dabei werden keinerlei eindeutige Nutzerdaten, wie IP-Adressen o. ä. gespeichert, welche zu direkten Rückschlüssen auf den jeweiligen Nutzer führen können.</p>
      <p>Optional können Profilnummer und Passwort an die vom Nutzer eingegebene E-Mail gesendet werden. Die E-Mail-Adresse wird dabei nicht gespeichert.</p>

      <h5>3. Rechtsgrundlage für die Datenverarbeitung</h5>
      <p>Rechtsgrundlage für die Verarbeitung der Daten ist die Einwilligung des Nutzers nach Art. 6 Abs. 1 lit. a DSG-VO i. V. m. § 46 HDSIG.</p>

      <h5>4. Dauer der Speicherung</h5>
      <p>Es werden hierfür keine personenbezogenen Daten von Hessen Mobil gespeichert.</p>

      <!-- ############################### -->
      <h4>Web Push-Benachrichtigungen</h4>

      <h5>1. Zweck der Datenverarbeitung</h5>
      <p>Um Kartenansichten, Routen und Push-Benachrichtigungen auf einem anderen Gerät zu nutzen oder dauer-haft zu speichern, kann der Nutzer sich ein persönliches Profil (Opt-In Verfahren) anlegen.</p>

      <h5>2. Beschreibung und Umfang der Datenverarbeitung</h5>
      <p>Hessen Mobil setzt Push-Benachrichtigungen mittels Service Worker bzw. auf mobilen Geräten die App PushNotifier ein. Push-Benachrichtigungen sind Meldungen, die ohne das Öffnen der Webseite oder der jeweiligen App auf Ihrem Endgerät angezeigt werden können.</p>
      <p>Dabei werden keinerlei eindeutige Nutzerdaten, wie IP-Adressen o. ä. gespeichert, welche zu direkten Rück-schlüssen auf den jeweiligen Nutzer führen können. Bei der Erstellung des Nutzerprofils (Opt-In Verfahren) werden lediglich ein Identifikationsschlüssel sowie die geographischen IP-Informationen (Land und Bundes-land) des Nutzers übertragen und in der Datenbank von TraffGo Road GmbH gespeichert. Dieser Schlüssel wird vom jeweiligen Browserhersteller (Google, Mozilla, Apple, etc.) vergeben und ermöglicht es, später die Benachrichtigungen an den jeweiligen Browser zu versenden. Der Versand erfolgt direkt über die Browserhersteller.</p>

      <h5>3.Rechtsgrundlage für die Datenverarbeitung</h5>
      <p>Rechtsgrundlage für die Verarbeitung der Daten ist die Einwilligung des Nutzers gemäß Art. 6 Abs. 1 lit. a DSGVO i. V. m. § 46 HDSIG.</p>

      <h5>5. Widerspruchs- und Beseitigungsmöglichkeit</h5>
      <p>
        Sie können dem Empfang von Benachrichtigungen jederzeit über die Einstellungen Ihres Browsers nach Art. 7 Abs. 3 Satz 1 DSGVO i. V. m. Art 21 Abs. 1 DSGVO und § 46 Abs. 3 HDSIG widersprechen. Informationen über die Abmeldung für Push-Benachrichtigungen für die jeweiligen Browser finden Sie hier:
        <a
          rel="noopener noreferrer"
          href="https://support.google.com/chrome/answer/3220216?co=GENIE.Platform%3DDesktop&hl=de"
          target="_blank"
        >Google Chrome</a>,
        <a
          rel="noopener noreferrer"
          href="https://support.mozilla.org/de/kb/push-benachrichtigungen-firefox#w_bestimmten-websites-die-erlaubnis-zum-senden-von-benachrichtigungen-wieder-entziehen"
          target="_blank"
        >Mozilla Firefox</a>,
        <a
          rel="noopener noreferrer"
          href="https://support.apple.com/de-de/guide/safari/sfri40734/mac"
          target="_blank"
        >Apple Safari</a>.
      </p>

      <!-- ############################### -->
      <h4>Umgang mit Ihren Daten</h4>
      <h5>1. Personenbezogene Daten</h5>
      <p>Personenbezogene Daten sind nach Art. 4 DSGVO und § 41 HDSIG alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person beziehen. Als identifizierbar wird eine natürliche Person angesehen, die direkt oder indirekt, insbesondere mittels Zuordnung zu einer Kennung wie einem Namen, zu einer Kennnummer, zu Standortdaten, zu einer Online-Kennung oder zu einem oder mehreren persönlichen Merkmalen identifiziert werden kann, die Ausdruck der physischen, physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen oder sozialen Identität dieser natürlichen Person sind.</p>

      <h5>2. Kontaktformular</h5>
      <p>Wenn Sie uns Daten zu Ihrer Person im Rahmen einer Anfrage über unser Kontaktformular zur Verfügung stellen, verwenden wir diese Daten zur Erfüllung unserer Aufgaben ausschließlich zu dem Zweck, zu dem sie uns diese Daten übermitteln, insbesondere zur Beantwortung Ihrer Fragen. Die Daten werden bei der Hessischen Zentrale für Datenverarbeitung gespeichert und nur für die Bearbeitung Ihres Anliegens von den fachlich zuständigen Personen verwendet.</p>
      <p>Zur Beantwortung Ihrer Fragen kann es je nach Sachlage erforderlich sein, Daten zu Ihrer Person auch an andere Stellen innerhalb der Landesverwaltung, Bundes- oder kommunale Behörden weiterzuleiten. Falls Sie damit nicht einverstanden sind, teilen Sie uns dies bitte unbedingt mit, indem Sie das dafür vorgesehene Optionsfeld in unserem Online-Formular entsprechend aktivieren.</p>
      <p>Sollte Hessen Mobil – Straßen- und Verkehrsmanagement für Ihr Anliegen nicht zuständig sein, leiten wir Ihre Eingabe an die zuständige Stelle weiter und informieren Sie darüber, dass Ihre Eingabe an die zuständige Stelle abgegeben wurde.</p>
      <p>
        Sollte Hessen Mobil – Straßen- und Verkehrsmanagement für Ihr Anliegen nicht zuständig sein, leiten wir Ihre Eingabe an die zuständige Stelle weiter und informieren Sie darüber, dass Ihre Eingabe an die zuständige Stelle abgegeben wurde.
        <a
          rel="noopener noreferrer"
          href="http://www.rv.hessenrecht.hessen.de/lexsoft/default/hessenrecht_rv.html#lawid:5454852,1"
          target="_blank"
        >http://www.rv.hessenrecht.hessen.de/</a>
      </p>

      <h5>3. Nutzungsdaten</h5>
      <p>Bei jedem Aufruf unserer Internetseite erfasst unser System gemäß § 15 Telemediengesetz (TMG) automatisiert Daten und Informationen vom Computersystem des aufrufenden Rechners.</p>
      <p>Folgende Daten werden hierbei erhoben:</p>
      <ul>
        <li>Name bzw. URL der abgerufenen Datei,</li>
        <li>Datum und Uhrzeit des Abrufs,</li>
        <li>übertragene Datenmenge,</li>
        <li>Meldung, ob der Abruf erfolgreich war,</li>
        <li>anonymisierte IP-Adresse.</li>
      </ul>
      <p>Die Daten werden ebenfalls in den Logfiles unseres Systems gespeichert. Eine Speicherung dieser Daten zusammen mit anderen personenbezogenen Daten des Nutzers findet nicht statt.</p>
      <p>
        Die Webseite
        <a
          rel="noopener noreferrer"
          href="https://www.verkehrsservice.hessen.de"
          target="_blank"
        >www.verkehrsservice.hessen.de</a> benutzt Matomo (ehemals Piwik), eine Open-Source-Software zur statistischen Auswertung der Besucherzugriffe. Matomo verwendet ebenfalls sog. Cookies, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre Benutzung dieses Internetangebotes werden auf den Webservern in Deutschland gespeichert. Die IP-Adresse wird sofort nach der Verarbeitung und vor deren Speicherung anonymisiert. Sie können die Installation der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich nutzen können.
      </p>

      <h5>4. Rechtsgrundlage für die Datenverarbeitung</h5>
      <p>Rechtsgrundlage für die vorübergehende Speicherung der Daten und der Logfiles ist Art. 6 Abs. 1 lit. a DSGVO i. V. m. § 42 HDSIG.</p>

      <h5>5. Zweck der Datenverarbeitung</h5>
      <p>Die vorübergehende Speicherung der IP-Adresse durch das System ist notwendig, um eine Auslieferung der Website an den Rechner des Nutzers zu ermöglichen. Hierfür muss die IP-Adresse des Nutzers für die Dauer der Sitzung gespeichert bleiben.</p>
      <p>Die Speicherung in Logfiles erfolgt, um die Funktionsfähigkeit der Website sicherzustellen. Zudem dienen uns die Daten zur Optimierung der Website und zur Sicherstellung der Sicherheit unserer informationstechnischen Systeme. Eine weitere Auswertung der Daten findet nicht statt.</p>

      <h5>6. Dauer der Speicherung</h5>
      <p>Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. Im Falle der Erfassung der Daten zur Bereitstellung der Website ist dies der Fall, wenn die jeweilige Sitzung beendet ist. Die Speicherung von Verkehrsdaten (Log-Dateien) erfolgt gemäß § 96 Telekommunikations-gesetz (TKG). Die Verkehrsdaten werden nach § 113b TKG spätestens nach 7 Tagen gelöscht.</p>

      <h5>7. Datensicherheit</h5>
      <p>Unsere Mitarbeiter und die von uns beauftragten technischen Dienstleister sind zur Verschwiegenheit und Einhaltung der Bestimmungen der anwendbaren Datenschutzgrundsätze gemäß Art. 5 ff. DSGVO i. V. m. § 42 HDSIG verpflichtet.</p>
      <p>Wir treffen alle erforderlichen technischen und organisatorischen Maßnahmen gemäß Art. 24 und 32 DSGVO i. V. m. § 42 HDSIG sowie § 13 TMG um ein angemessenes Schutzniveau zu gewährleisten. Hierzu zählt der Schutz vor unbefugter oder unrechtmäßiger Verarbeitung, unbeabsichtigtem Verlust, unbeabsichtigter Zerstörung oder unbeabsichtigter Schädigung.</p>

      <!-- ############################### -->
      <h4>Verwendung von Cookies</h4>

      <h5>1. Beschreibung und Umfang der Datenverarbeitung</h5>
      <p>Unsere Webseite verwendet Cookies. Bei Cookies handelt es sich um Textdateien, die im Internetbrowser bzw. vom Internetbrowser auf dem Computersystem des Nutzers gespeichert werden. Ruft ein Nutzer eine Website auf, so kann ein Cookie auf dem Betriebssystem des Nutzers gespeichert werden. Dieser Cookie enthält eine charakteristische Zeichenfolge, die eine eindeutige Identifizierung des Browsers beim erneuten Aufrufen der Website ermöglicht.</p>
      <p>Wir setzen Cookies ein, um unsere Website nutzerfreundlicher zu gestalten. Einige Elemente unserer Internetseite erfordern es, dass der aufrufende Browser auch nach einem Seitenwechsel identifiziert werden kann.</p>
      <p>In den Cookies werden dabei folgende Daten gespeichert und übermittelt:</p>
      <ul>
        <li>Spracheinstellungen</li>
        <li>eindeutige Identifizierung des Browsers</li>
      </ul>

      <h5>2. Rechtsgrundlage für die Datenverarbeitung</h5>
      <p>Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung von Cookies ist Art. 6 Abs. 1 lit. a DSGVO i. V. m. § 42 HDSIG.</p>

      <h5>3. Zweck der Datenverarbeitung</h5>
      <p>Der Zweck der Verwendung technisch notwendiger Cookies ist, die Nutzung von Websites für die Nutzer zu vereinfachen. Einige Funktionen unserer Internetseite können ohne den Einsatz von Cookies nicht angeboten werden. Für diese ist es erforderlich, dass der Browser auch nach einem Seitenwechsel wiedererkannt wird.</p>
      <p>Die durch technisch notwendige Cookies erhobenen Nutzerdaten werden nicht zur Erstellung von Nutzerprofilen verwendet.</p>

      <h5>4. Dauer der Speicherung, Widerspruchs- und Beseitigungsmöglichkeit</h5>
      <p>Cookies werden auf dem Rechner des Nutzers gespeichert und von diesem an unserer Seite übermittelt. Daher haben Sie als Nutzer auch die volle Kontrolle über die Verwendung von Cookies. Durch eine Änderung der Einstellungen in Ihrem Internetbrowser können Sie die Übertragung von Cookies deaktivieren oder einschränken. Bereits gespeicherte Cookies können jederzeit gelöscht werden. Dies kann auch automatisiert erfolgen. Werden Cookies für unsere Website deaktiviert, können möglicherweise nicht mehr alle Funktionen der Website vollumfänglich genutzt werden.</p>

      <!-- ############################### -->
      <h4>Webhosting</h4>

      <h5>1. Beschreibung und Umfang der Datenverarbeitung</h5>
      <p>Unserer Internetseite wird von Dienstleistern betrieben, welche die Pflege der Webseiten übernehmen sowie die dahinterliegenden Datenbanksysteme verwalten. Insofern werden alle oben genannten Daten über die Systeme der Dienstleister geleitet.</p>

      <h5>2.Rechtsgrundlage für die Datenverarbeitung</h5>
      <p>Rechtsgrundlage für die Verarbeitung der Daten ist bei Vorliegen einer Einwilligung des Nutzers Art. 6 Abs. 1 lit. a DSGVO i. V. m. § 42 HDSIG.</p>
      <p>Mit den Dienstleistern bestehen Auftragsverarbeitungsvereinbarungen nach Art. 28 DSGVO i. V. m. § 57 HDSIG die einen datenschutzrechtlich konformen Umgang mit den Daten sicherstellen.</p>

      <h5>3. Zweck der Datenverarbeitung</h5>
      <p>Eine Betreuung und der Betrieb unserer Internetseite durch spezialisierte Unternehmen ist notwendig, um einen störungsfreie und effiziente Benutzbarkeit sicherzustellen.</p>

      <h5>4. Dauer der Speicherung</h5>
      <p>Die Dauer der Speicherung der unterschiedlichen Datenarten wurde in den vorigen Kapiteln detailliert erörtert.</p>

      <h5>5. Widerspruchs- und Beseitigungsmöglichkeit</h5>
      <p>Die Widerspruchs- und Beseitigungsmöglichkeiten der unterschiedlichen Datenarten werden in den nachfolgenden Kapiteln detailliert beschrieben.</p>

      <!-- ############################### -->
      <h4>Ihre Rechte</h4>

      <p>Als Nutzer unseres Internetangebots haben Sie nach der Datenschutzgrundverordnung und dem Hessischen Datenschutz- und Informationsfreiheitsgesetz verschiedene Rechte, die sich insbesondere aus Art. 15 bis 18 und 21 DSGVO sowie den §§ 52 und 53 HDSIG ergeben:</p>

      <h5>1. Recht auf Auskunft</h5>
      <p>Sie können nach Art. 15 DSGVO oder § 52 HDSIG Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten verlangen. In Ihrem Auskunftsantrag sollten Sie Ihr Anliegen präzisieren, um uns das Zusammenstellen der erforderlichen Daten zu erleichtern. Bitte beachten Sie, dass Ihr Auskunftsrecht durch die Vorschriften der §§ 24 Abs. 2, 26 Abs. 2 und 33 HDSIG sowie § 52 Abs. 2 bis 5 HDSIG eingeschränkt wird.</p>

      <h5>2. Recht auf Berichtigung</h5>
      <p>Sollten die Sie betreffenden Angaben nicht (mehr) zutreffend sein, können Sie nach Art. 16 DSGVO oder § 53 HDSIG eine Berichtigung verlangen. Sollten Ihre Daten unvollständig sein, können Sie eine Vervollständigung verlangen.</p>

      <h5>3. Recht auf Löschung</h5>
      <p>Unter den Bedingungen des Art. 17 DSGVO und der §§ 34 und 53 HDSIG können Sie die Löschung Ihrer personenbezogenen Daten verlangen. Ihr Anspruch auf Löschung hängt u. a. davon ab, ob die Sie betreffenden Daten von uns zur Erfüllung unserer gesetzlichen Aufgaben noch benötigt werden.</p>

      <h5>4. Recht auf Einschränkung der Verarbeitung</h5>
      <p>Im Rahmen der Vorgaben des Art. 18 DSGVO und § 53 HDSIG haben Sie das Recht, eine Einschränkung der Verarbeitung der Sie betreffenden Daten zu verlangen.</p>

      <h5>5. Recht auf Widerspruch</h5>
      <p>Nach Art. 21 DSGVO i. V. m. § 35HDSIG haben Sie das Recht aus Gründen, die sich aus Ihrer besonderen Situ-ation ergeben, jederzeit der Verarbeitung der Sie betreffenden Daten zu widersprechen. Allerdings können wir dem nicht immer nachkommen, z. B. wenn uns im Sinne von § 35 HDSIG im Rahmen unserer amtlichen Aufgabenerfüllung eine Rechtsvorschrift zur Verarbeitung verpflichtet.</p>

      <h5>6. Recht auf Beschwerde</h5>
      <p>Wenn Sie der Auffassung sind, dass wir bei der Verarbeitung Ihrer Daten datenschutzrechtliche Vorschriften nicht beachtet haben, können Sie sich mit einer Beschwerde an die zuständige Aufsichtsbehörde wenden. Das ist der Hessische Beauftragte für Datenschutz und Informationsfreiheit, Gustav-Stresemann-Ring 1, 65189 Wiesbaden, Tel. 0611/1408-0.</p>
      <p>
        Allgemeine Informationen zum Datenschutz finden Sie auf den Internetseiten des Hessischen Datenschutzbeauftragten
        <br>(
        <a rel="noopener noreferrer" href="https://www.datenschutz.hessen.de" target="_blank">www.datenschutz.hessen.de</a>).
      </p>
      <iframe
        style="border: 0; height: 300px; width: 350px;"
        src="http://vzhstatistik.traffgoroad.com/index.php?module=CoreAdminHome&action=optOut&language=de"
      ></iframe>
    </div>
  </div>
</template>

<script>
import Header from "./../CoreComponents/Header.vue";
export default {
  name: "Datenschutz",
  components: { Header },
  data: function() {
    return {};
  },
  computed: {
    device() {
      return this.$store.state.device;
    }
  },
  methods: {
    closeSidebar() {
      this.$emit("close");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.datenschutzContainer {
  height: 100%;
  width: 100%;
}

.content {
  width: calc(10.75 / 12 * 100%);
}

.datenschutzContent {
  height: calc(100% - 95px);
  overflow-y: auto;
  padding-right: 5px;
}

h5 {
  font-weight: 600;
}
</style>
